/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre",
    blockquote: "blockquote",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "withTheme"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This is a higher order component factory to get the current theme from a ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), " and\npass it to your component as a ", _jsx(_components.code, {
        children: "theme"
      }), " prop."]
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "Component"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: ["Any valid React component that can handle a ", _jsx(Code, {
              children: "theme"
            }), " prop."]
          })
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Returns the passed component inside a wrapper (higher order component).\nThe passed component will receive a ", _jsx(_components.code, {
        children: "theme"
      }), " prop with the current theme object."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { withTheme } from 'styled-components'\n\nclass MyComponent extends React.Component {\n  render() {\n    console.log('Current theme: ', this.props.theme)\n    // ...\n  }\n}\n\nexport default withTheme(MyComponent)\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["All styled components ", _jsx(_components.a, {
          href: "/docs/advanced#theming",
          children: "automatically receive the theme as a prop"
        }), ", so this is only necessary if you wish to access the theme for other reasons."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
